const community = () => import('@/pages/statistics/community/index.vue');

export default [{
    path: '/statistics/community',
    component: community,
    meta: [{
        name: '统计分析'
    },
    {
        name: '社区分析',
        activeRoute: '/statistics/community'
    }]
}];